/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { Text, Title } from '@components/v2/ui';
import {
	ActionIcon,
	Affix,
	Box,
	Flex,
	Group,
	List,
	Stack,
	Transition,
} from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';
import {
	IconArrowNarrowLeft,
	IconArrowNarrowUp,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import classe from './cgu.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const CGUFR = () => {
	const [scroll, scrollTo] = useWindowScroll();
	const navigate = useNavigate();

	const handleGoToPreviousPage = () => {
		navigate(-1);
	};
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classe.container} w="100%">
			<Box className={classe.header}>
				<Flex
					justify={'space-between'}
					gap={'12px'}
					align={'center'}
					wrap={'wrap'}
				>
					<Group
						style={{
							cursor: 'pointer',
						}}
						onClick={handleGoToPreviousPage}
					>
						<ActionIcon
							color={'#ADD2EA'}
							variant="outline"
							size="48px"
							radius="xl"
							aria-label="Settings"
						>
							<IconArrowNarrowLeft
								style={{ width: '70%', height: '70%' }}
								stroke={1.5}
								color={'#727272'}
							/>
						</ActionIcon>
						<Box>
							<Text
								style={{
									cursor: 'pointer',
								}}
								c={'#1D3965'}
								variant="body1"
							>
								Retour à la page précédente
							</Text>
						</Box>
					</Group>

					<Text c={'#1D3965'} variant="body1">
						Mise à jour : 19/11/2025 10:18
					</Text>
				</Flex>
			</Box>

			<Box className={classe.content}>
				<Stack gap={'5px'}>
					<Title
						style={{
							textAlign: 'center',
						}}
						c={'#1D3965'}
						order={3}
					>
						Conditions Générales d’Utilisation <br />
						de la plateforme Iglu
					</Title>
				</Stack>

				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						0. Définitions
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Client (ci-après « Client ») : personne
						physique ou morale ayant conclu un contrat
						avec Inuk pour acheter des crédits carbone.
						<br />
						<br />
						Producteur (ci-après « Producteur ») :
						personne morale ayant pour activité le
						développement de projets de décarbonation –
						projets qui sont référencés sur la Plateforme
						Iglu – et habilitée à transmettre et suivre
						ses données de production.
						<br />
						<br />
						Partenaire (ci-après « Partenaire ») :
						personne morale ayant pour activité la gestion
						d’un portefeuille de projets de décarbonation
						et de clients sur la Plateforme Iglu, en
						accédant aux données de suivi des projets, de
						production et des offsets réalisés par les
						Clients.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						1. Objet
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Les présentes Conditions Générales
						d’Utilisation (ci-après « CGU ») ont pour
						objet de définir les modalités et conditions
						d’accès et d’utilisation de la plateforme Iglu
						(ci-après « la Plateforme »), éditée et
						exploitée par la société Inuk (ci-après « Inuk
						»).
						<br />
						<br />
						Iglu est une solution numérique permettant :
						<br />
						<br />
						<List>
							<List.Item>
								aux Clients : de consulter leurs
								opérations de compensation carbone («
								offsets »), d’accéder à l’historique de
								leurs transactions ainsi qu’aux
								certificats associés ;
							</List.Item>
							<List.Item>
								aux Producteurs : de gérer leurs projets
								de production d’énergie renouvelable
								certifié par INUK, de transmettre leurs
								données de production et d’en assurer le
								suivi ;
							</List.Item>
							<List.Item>
								aux Partenaires : de gérer un portefeuille
								de projets et de clients, en accédant aux
								données de suivi des projets, de
								production et des offsets réalisés par les
								Clients.
							</List.Item>
						</List>
						Les présentes CGU constituent un contrat
						juridiquement contraignant entre Inuk et
						l’Utilisateur de la Plateforme (ci-après «
						l’Utilisateur »), quel que soit son profil
						(Client, Producteur, Partenaire).
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						2. Documents contractuels
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						La relation contractuelle entre le Client et
						Inuk est régie, par ordre hiérarchique
						décroissant, par les documents suivants :
						<br />
						<br />
						<List>
							<List.Item>
								Règles et Exigences Standard d’INUK : en
								cas d’incohérence entre les présentes
								Conditions Générales d’Utilisation de la
								plateforme Iglu et les Règles et Exigences
								Standard d’INUK, ces dernières prévaudront
								sur les Conditions Générales d’Utilisation
								de la plateforme Iglu.
							</List.Item>
							<List.Item>
								Conditions Générales d’Utilisation de la
								plateforme Iglu : le Client accepte ces
								Conditions en cochant une case dans le
								formulaire d’inscription. Si le Client
								n’accepte pas ces Conditions
								d’Utilisation, il ne pourra pas accéder à
								la Plateforme Iglu.
							</List.Item>
						</List>
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						3. Champ d’application et acceptation
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						L’accès à la Plateforme est réservé aux
						personnes expressément autorisées par Inuk
						dans le cadre d’une relation contractuelle.
						<br />
						<br />
						La création de comptes est effectuée
						exclusivement par les équipes d’Inuk, sur la
						base des informations transmises par les
						organisations clientes, productrices ou
						partenaires.
						<br />
						<br />
						En accédant à la Plateforme, l’Utilisateur
						reconnaît avoir pris connaissance des
						présentes CGU et les accepter sans réserve.
						Toute utilisation de la Plateforme implique
						l’adhésion pleine et entière aux présentes
						conditions.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						4. Création et gestion des comptes
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						<Text c={'#1D3965'} variant="subtitle1" span>
							4.1. Modalités de création
						</Text>
						<br />
						<br />
						<List>
							<List.Item>
								Pour les Clients : l’accès est ouvert
								automatiquement à la suite de la
								validation d’une demande de contribution
								adressée à Inuk. La contribution est
								considérée comme validée à compter de la
								date d’encaissement effectif du paiement
								de la facture émise par Inuk au Client.
							</List.Item>
							<List.Item>
								Pour les Producteurs : l’accès est ouvert
								lors de la certification et l’intégration
								d’un projet sur la Plateforme.
							</List.Item>
							<List.Item>
								Pour les Partenaires : l’accès est accordé
								dans le cadre d’un partenariat contractuel
								et limité aux missions de suivi et de
								gestion confiées par Inuk.
							</List.Item>
						</List>
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							4.2. Données collectées
						</Text>
						<br />
						<br />
						Les informations suivantes sont recueillies
						pour la création des comptes d&#39;accès à la
						plateforme : nom, prénom, adresse e-mail
						professionnelle et, de manière facultative, un
						numéro de téléphone professionnel.
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							4.3. Responsabilité de l’Utilisateur
						</Text>
						<br />
						<br />
						L’Utilisateur est seul responsable du maintien
						de la confidentialité de ses identifiants et
						de l’usage qui en est fait. Toute connexion ou
						transmission de données effectuée au moyen de
						ses identifiants sera réputée effectuée par
						lui.
						<br />
						<br />
						L’Utilisateur s’engage à fournir des
						informations exactes et à informer Inuk de
						toute modification.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						5. Droits d’accès et utilisation de la
						Plateforme
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						<Text c={'#1D3965'} variant="subtitle1" span>
							5.1. Droits spécifiques par profil
						</Text>
						<br />
						<br />
						<List>
							<List.Item>
								Client : accès aux offsets réalisés, aux
								certificats correspondants et à
								l’historique des compensations.
							</List.Item>
							<List.Item>
								Producteur : accès à ses projets,
								transmission des données de production,
								suivi de l’historique des productions.
							</List.Item>
							<List.Item>
								Partenaire/gestionnaire : accès aux
								projets suivis, aux données de production
								ainsi qu’aux informations relatives aux
								clients et à leurs offsets.
							</List.Item>
						</List>
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							5.2. Règles de bonne utilisation
						</Text>
						<br />
						<br />
						L’Utilisateur s’interdit, notamment :
						<List>
							<List.Item>
								d’accéder ou de tenter d’accéder à des
								données ou espaces qui ne lui sont pas
								destinés;
							</List.Item>
							<List.Item>
								de porter atteinte à l’intégrité ou au bon
								fonctionnement de la Plateforme ;
							</List.Item>
							<List.Item>
								d’utiliser la Plateforme à des fins
								frauduleuses, illicites ou non conformes à
								sa finalité.
							</List.Item>
						</List>
						<br />
						<br />
						Tout manquement pourra entraîner la suspension
						ou la suppression immédiate du compte par
						Inuk, sans préjudice d’éventuelles poursuites
						judiciaires.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						6. Tarification de la plateforme
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						<Text c={'#1D3965'} variant="subtitle1" span>
							6.1. Clients et Producteurs
						</Text>
						<br />
						<br />
						L’accès à la Plateforme Iglu est gratuit pour
						les Clients et les Producteurs certifés par
						Inuk.
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							6.2. Partenaires
						</Text>
						<br />
						<br />
						L’accès pour les Partenaires/gestionnaires est
						soumis à des frais de maintenance et
						d’évolution de la Plateforme.
						<br />
						<br />
						Les modalités tarifaires et conditions de
						paiement sont précisées dans le contrat de
						partenariat conclu avec Inuk.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						7. Propriété intellectuelle
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						La Plateforme Iglu, ainsi que l’ensemble de
						ses composants techniques, graphiques,
						textuels et fonctionnels (hors données
						fournies par les Utilisateurs), sont la
						propriété exclusive d’Inuk et protégés par le
						droit de la propriété intellectuelle.
						<br />
						<br />
						Toute reproduction, représentation,
						modification, adaptation ou exploitation non
						autorisée, totale ou partielle, est
						strictement interdite et pourra donner lieu à
						des poursuites.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						8. Responsabilités
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						<Text c={'#1D3965'} variant="subtitle1" span>
							8.1. Responsabilité d’Inuk
						</Text>
						<br />
						<br />
						Inuk s’engage à mettre en œuvre les moyens
						raisonnables pour assurer un accès continu et
						sécurisé à la Plateforme. Toutefois, Inuk ne
						garantit pas une disponibilité ininterrompue
						et ne saurait être tenue responsable en cas de
						dysfonctionnement, interruption ou perte de
						données imputable à des tiers ou à un cas de
						force majeure.
						<br />
						<br />
						Les données accessibles sur la Plateforme ont
						une valeur informative. Les documents
						contractuels (devis, factures, conventions)
						demeurent les seules références juridiquement
						opposables.
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							8.2. Responsabilité de l’Utilisateur
						</Text>
						<br />
						<br />
						L’Utilisateur est seul responsable de l’usage
						de la Plateforme et des informations
						auxquelles il accède. Il lui appartient de
						s’assurer de la compatibilité de ses
						équipements avec la Plateforme et de prendre
						toutes les mesures nécessaires pour protéger
						ses données et systèmes informatiques.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						9. Protection des données personnelles
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Inuk collecte et traite des données à
						caractère professionnel (nom, prénom, e-mail
						professionnel, numéro de téléphone facultatif)
						pour les seules finalités de gestion des accès
						à la Plateforme et de fourniture du service.
						<br />
						<br />
						Ces traitements reposent sur l’exécution
						contractuelle entre Inuk et les organisations
						clientes, productrices ou partenaires.
						<br />
						<br />
						Conformément au Règlement Général sur la
						Protection des Données (RGPD) et à la loi
						Informatique et Libertés, chaque Utilisateur
						dispose d’un droit d’accès, de rectification,
						de suppression, de limitation, d’opposition et
						de portabilité de ses données.
						<br />
						<br />
						Ces droits peuvent être exercés en adressant
						une demande à l’adresse de contact indiquée à
						l’Article « Contact » ci-dessous.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						10. Hébergement et traçabilité des données
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						<Text c={'#1D3965'} variant="subtitle1" span>
							10.1. Hébergement des données
						</Text>
						<br />
						<br />
						Les données de la Plateforme Iglu sont
						hébergées par OVH, fournisseur certifié
						répondant aux normes de sécurité et de
						disponibilité en vigueur.
						<br />
						<br />
						<Text c={'#1D3965'} variant="subtitle1" span>
							10.2. Traçabilité
						</Text>
						<br />
						<br />
						Toutes les transactions réalisées sur la
						plateforme Iglu sont systématiquement
						transcrites sur une blockchain publique,
						garantissant leur immutabilité et leur
						traçabilité.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						11. Suspension et résiliation
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Inuk se réserve le droit de suspendre,
						restreindre ou supprimer l’accès d’un
						Utilisateur à la Plateforme en cas de
						non-respect des présentes CGU, ou à la demande
						de l’organisation dont il dépend.
						<br />
						<br />
						La cessation de la relation contractuelle
						entre Inuk et une organisation entraîne la
						suppression des comptes rattachés à cette
						organisation.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						12. Modification des CGU
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Inuk se réserve le droit de modifier les
						présentes CGU à tout moment, afin notamment de
						les adapter aux évolutions légales,
						réglementaires ou techniques.
						<br />
						<br />
						Les Utilisateurs seront informés de ces
						modifications par tout moyen approprié. La
						poursuite de l’utilisation de la Plateforme
						emporte acceptation des CGU ainsi modifiées.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						13. Loi applicable et juridiction compétente
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Les présentes CGU sont régies par le droit
						français.
						<br />
						<br />
						Tout litige relatif à leur interprétation,
						leur validité ou leur exécution sera soumis à
						la compétence exclusive des tribunaux du
						ressort du siège social d’Inuk, sauf
						disposition légale impérative contraire.
					</Text>
				</Box>
				{/* Bloc text */}
				<Box>
					<Title
						pb={'15px'}
						pl={'24px'}
						c={'#1D3965'}
						order={4}
					>
						14. Contact
					</Title>
					<Text
						style={{
							textAlign: 'justify',
						}}
						c={'#1D3965'}
						variant="body1"
					>
						Pour toute question relative à l’utilisation
						de la Plateforme ou à l’exercice de vos droits
						au titre du RGPD, vous pouvez contacter :{' '}
						<br />
						Le responsable du traitement des données est :
						Rym Kadry, rym@inuk.co
						<br />
						Adresse : 13 rue Santeuil 75005 paris
						<br />
						Email : tech@inuk.co
					</Text>
				</Box>
			</Box>

			<Box
				style={{
					marginTop: '96px',
					height: '38px',
					backgroundColor: '#1D3965',
				}}
			></Box>

			<Affix position={{ bottom: 20, right: 20 }}>
				<Transition
					transition="slide-up"
					mounted={scroll.y > 0}
				>
					{() => (
						<ActionIcon
							onClick={() => scrollTo({ y: 0 })}
							color={'#ADD2EA'}
							variant="outline"
							size="48px"
							radius="xl"
							aria-label="Settings"
						>
							<IconArrowNarrowUp
								style={{ width: '70%', height: '70%' }}
								stroke={1.5}
								color={'#727272'}
							/>
						</ActionIcon>
					)}
				</Transition>
			</Affix>
		</Box>
	);
};

export default CGUFR;
